module.exports = __webpack_public_path__ + "./fonts/b3c7c514e64914198e23c08ba49ce9bf.woff2";